import { AGENT_TYPE_VALUES, AgentTypeValue } from 'app/utils/agentType';

/**
 * Resource identifier used by `withResourceProtection` HOC.
 * Add an entry with this `name`/`component` to `resource_mappings` in the
 * login API response to grant a user access to the global agent type filter.
 */
export const AGENT_TYPE_DROPDOWN_RESOURCE = 'AgentTypeDropdown';

export type AgentTypeOption = {
  label: string;
  value: AgentTypeValue;
  disabled?: boolean;
};

/**
 * Dropdown options shown in the header. Order matches the spec mockup.
 */
export const AGENT_TYPE_OPTIONS: AgentTypeOption[] = [
  { label: 'Unsold Nurturing', value: AGENT_TYPE_VALUES.UNSOLD_NURTURING },
  { label: 'Sold Nurturing', value: AGENT_TYPE_VALUES.SOLD_NURTURING },
  {
    label: 'Service Nurturing',
    value: AGENT_TYPE_VALUES.SERVICE_NURTURING,
    disabled: true,
  },
  {
    label: 'Lease Return Nurturing',
    value: AGENT_TYPE_VALUES.LEASE_RETURN_NURTURING,
    disabled: true,
  },
];

/** Sentinel value used by MUI Select to represent "nothing selected". */
export const AGENT_TYPE_NONE_VALUE = '';

/** Label shown for the "no filter applied" option. */
export const AGENT_TYPE_NONE_LABEL = 'All Agent Types';
